<template>
  <div v-if="notification && propsNotificationBase">
    <PmNotificationErrorPure
      v-if="notification.type === 'NotificationError'"
      v-bind="{ ...propsNotificationBase, ...notification.props }"
    />

    <PmNotificationResourceRequestFeedback
      v-if="notification.type === 'ResourceRequestFeedbackStateUpdated'"
      v-bind="{ ...propsNotificationBase, ...notification.props }"
    />

    <PmNotificationResourceRequestMessage
      v-if="notification.type === 'ResourceRequestCommented'"
      v-bind="{ ...propsNotificationBase, ...notification.props }"
    />

    <PmNotificationResourceRequestUpdated
      v-if="notification.type === 'NotificationResourceRequestUpdated'"
      v-bind="{ ...propsNotificationBase, ...notification.props }"
    />

    <PmNotificationAddressUpdated
      v-if="notification.type === 'NotificationAddressUpdated'"
      v-bind="{ ...propsNotificationBase, ...notification.props }"
    />

    <PmNotificationLeaveRequestCreated
      v-if="notification.type === 'NotificationLeaveRequestCreated'"
      v-bind="{ ...propsNotificationBase, ...notification.props }"
    />

    <PmNotificationLeaveRequestAborted
      v-if="notification.type === 'NotificationLeaveRequestAborted'"
      v-bind="{ ...propsNotificationBase, ...notification.props }"
    />

    <PmNotificationLeaveRequestUpdated
      v-if="notification.type === 'NotificationLeaveRequestUpdated'"
      v-bind="{ ...propsNotificationBase, ...notification.props }"
    />

    <PmNotificationLeaveRequestAccepted
      v-if="notification.type === 'NotificationLeaveRequestAccepted'"
      v-bind="{ ...propsNotificationBase, ...notification.props }"
    />

    <PmNotificationLeaveRequestAcceptedNotice
      v-if="notification.type === 'NotificationLeaveRequestAcceptedNotice'"
      v-bind="{ ...propsNotificationBase, ...notification.props }"
    />

    <PmNotificationLeaveRequestPartiallyAccepted
      v-if="notification.type === 'NotificationLeaveRequestPartiallyAccepted'"
      v-bind="{ ...propsNotificationBase, ...notification.props }"
    />

    <PmNotificationLeaveRequestDeclined
      v-if="notification.type === 'NotificationLeaveRequestDeclined'"
      v-bind="{ ...propsNotificationBase, ...notification.props }"
    />

    <PmNotificationLeaveRequestDeclinedNotice
      v-if="notification.type === 'NotificationLeaveRequestDeclinedNotice'"
      v-bind="{ ...propsNotificationBase, ...notification.props }"
    />

    <PmNotificationLeaveRequestCancelRequested
      v-if="notification.type === 'NotificationLeaveRequestCancelRequested'"
      v-bind="{ ...propsNotificationBase, ...notification.props }"
    />

    <PmNotificationLeaveRequestCancelDeclined
      v-if="notification.type === 'NotificationLeaveRequestCancelDeclined'"
      v-bind="{ ...propsNotificationBase, ...notification.props }"
    />

    <PmNotificationLeaveRequestCancelDeclinedNotice
      v-if="
        notification.type === 'NotificationLeaveRequestCancelDeclinedNotice'
      "
      v-bind="{ ...propsNotificationBase, ...notification.props }"
    />

    <PmNotificationLeaveRequestCancelAccepted
      v-if="notification.type === 'NotificationLeaveRequestCancelAccepted'"
      v-bind="{ ...propsNotificationBase, ...notification.props }"
    />

    <PmNotificationLeaveRequestCancelAcceptedNotice
      v-if="
        notification.type === 'NotificationLeaveRequestCancelAcceptedNotice'
      "
      v-bind="{ ...propsNotificationBase, ...notification.props }"
    />

    <PmNotificationLeaveRequestCancelPartiallyAccepted
      v-if="
        notification.type === 'NotificationLeaveRequestCancelPartiallyAccepted'
      "
      v-bind="{ ...propsNotificationBase, ...notification.props }"
    />

    <PmNotificationExternalServiceRequestCreated
      v-if="notification.type === 'NotificationExternalServiceRequestCreated'"
      v-bind="{ ...propsNotificationBase, ...notification.props }"
    />

    <PmNotificationExternalServiceRequestUpdated
      v-if="notification.type === 'NotificationExternalServiceRequestUpdated'"
      v-bind="{ ...propsNotificationBase, ...notification.props }"
    />

    <PmNotificationExternalServiceRequestAccepted
      v-if="notification.type === 'NotificationExternalServiceRequestAccepted'"
      v-bind="{ ...propsNotificationBase, ...notification.props }"
    />

    <PmNotificationExternalServiceRequestAcceptedNotice
      v-if="
        notification.type === 'NotificationExternalServiceRequestAcceptedNotice'
      "
      v-bind="{ ...propsNotificationBase, ...notification.props }"
    />

    <PmNotificationExternalServiceRequestDeclined
      v-if="notification.type === 'NotificationExternalServiceRequestDeclined'"
      v-bind="{ ...propsNotificationBase, ...notification.props }"
    />

    <PmNotificationExternalServiceRequestDeclinedNotice
      v-if="
        notification.type === 'NotificationExternalServiceRequestDeclinedNotice'
      "
      v-bind="{ ...propsNotificationBase, ...notification.props }"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

const COMPONENT_NAME = 'PmNotification'

export const propTypes = {} as const

export default defineComponent({
  name: COMPONENT_NAME,
})
</script>

<script setup lang="ts">
import { computed } from 'vue'

import notifications from '@/store/notifications/notifications'
import { type Props as PropsNotificationContainerPure } from '@/components/PmNotification/PmNotificationContainerPure.vue'
import PmNotificationResourceRequestFeedback from '@/components/PmNotification/PmNotificationResourceRequestFeedback/PmNotificationResourceRequestFeedback.vue'
import PmNotificationLeaveRequestCreated from '@/components/PmNotification/PmNotificationLeaveRequestCreated/PmNotificationLeaveRequestCreated.vue'
import PmNotificationLeaveRequestAborted from '@/components/PmNotification/PmNotificationLeaveRequestAborted/PmNotificationLeaveRequestAborted.vue'
import PmNotificationLeaveRequestUpdated from '@/components/PmNotification/PmNotificationLeaveRequestUpdated/PmNotificationLeaveRequestUpdated.vue'
import PmNotificationLeaveRequestAccepted from '@/components/PmNotification/PmNotificationLeaveRequestAccepted/PmNotificationLeaveRequestAccepted.vue'
import PmNotificationLeaveRequestDeclined from '@/components/PmNotification/PmNotificationLeaveRequestDeclined/PmNotificationLeaveRequestDeclined.vue'
import PmNotificationLeaveRequestCancelRequested from '@/components/PmNotification/PmNotificationLeaveRequestCancelRequested/PmNotificationLeaveRequestCancelRequested.vue'
import PmNotificationLeaveRequestCancelDeclined from '@/components/PmNotification/PmNotificationLeaveRequestCancelDeclined/PmNotificationLeaveRequestCancelDeclined.vue'
import PmNotificationLeaveRequestCancelAccepted from '@/components/PmNotification/PmNotificationLeaveRequestCancelAccepted/PmNotificationLeaveRequestCancelAccepted.vue'
import PmNotificationExternalServiceRequestCreated from '@/components/PmNotification/PmNotificationExternalServiceRequestCreated/PmNotificationExternalServiceRequestCreated.vue'
import PmNotificationExternalServiceRequestUpdated from '@/components/PmNotification/PmNotificationExternalServiceRequestUpdated/PmNotificationExternalServiceRequestUpdated.vue'
import PmNotificationExternalServiceRequestAccepted from '@/components/PmNotification/PmNotificationExternalServiceRequestAccepted/PmNotificationExternalServiceRequestAccepted.vue'
import PmNotificationExternalServiceRequestDeclined from '@/components/PmNotification/PmNotificationExternalServiceRequestDeclined/PmNotificationExternalServiceRequestDeclined.vue'
import PmNotificationResourceRequestMessage from './PmNotificationResourceRequestMessage/PmNotificationResourceRequestMessage.vue'
import PmNotificationErrorPure from '@/components/PmNotification/PmNotificationError/PmNotificationErrorPure.vue'
import PmNotificationResourceRequestUpdated from '@/components/PmNotification/PmNotificationResourceRequestUpdated/PmNotificationResourceRequestUpdated.vue'
import PmNotificationAddressUpdated from '@/components/PmNotification/PmNotificationAddressUpdated/PmNotificationAddressUpdated.vue'
import PmNotificationLeaveRequestAcceptedNotice from '@/components/PmNotification/PmNotificationLeaveRequestAcceptedNotice/PmNotificationLeaveRequestAcceptedNotice.vue'
import PmNotificationLeaveRequestPartiallyAccepted from '@/components/PmNotification/PmNotificationLeaveRequestPartiallyAccepted/PmNotificationLeaveRequestPartiallyAccepted.vue'
import PmNotificationLeaveRequestDeclinedNotice from '@/components/PmNotification/PmNotificationLeaveRequestDeclinedNotice/PmNotificationLeaveRequestDeclinedNotice.vue'
import PmNotificationLeaveRequestCancelAcceptedNotice from '@/components/PmNotification/PmNotificationLeaveRequestCancelAcceptedNotice/PmNotificationLeaveRequestCancelAcceptedNotice.vue'
import PmNotificationLeaveRequestCancelPartiallyAccepted from '@/components/PmNotification/PmNotificationLeaveRequestCancelPartiallyAccepted/PmNotificationLeaveRequestCancelPartiallyAccepted.vue'
import PmNotificationLeaveRequestCancelDeclinedNotice from '@/components/PmNotification/PmNotificationLeaveRequestCancelDeclinedNotice/PmNotificationLeaveRequestCancelDeclinedNotice.vue'
import PmNotificationExternalServiceRequestAcceptedNotice from '@/components/PmNotification/PmNotificationExternalServiceRequestAcceptedNotice/PmNotificationExternalServiceRequestAcceptedNotice.vue'
import PmNotificationExternalServiceRequestDeclinedNotice from '@/components/PmNotification/PmNotificationExternalServiceRequestDeclinedNotice/PmNotificationExternalServiceRequestDeclinedNotice.vue'

export interface Props {
  id: number
}

const props = withDefaults(defineProps<Props>(), {})

const notification = computed(() => {
  return notifications.notifications.value?.get(props.id)
})

const propsNotificationBase = computed(() => {
  if (!notification.value) return

  const container = {
    date: notification.value.date,
    isUnread: notification.value.isUnread,
  } satisfies Pick<PropsNotificationContainerPure, 'date' | 'isUnread'>

  return {
    ...container,
    onMarkAsRead: markAsRead,
    onMarkAsUnread: markAsUnread,
  }
})

function markAsRead() {
  if (!notification.value) return
  notifications.markAsRead(notification.value.id)
}

function markAsUnread() {
  if (!notification.value) return
  notifications.markAsUnread(notification.value.id)
}
</script>
